import React, { useCallback, useEffect, useState } from 'react'
import PropTypes from 'prop-types'

import { InputBaseStyle } from '../../ModalApp.style'

const NumericFormatModal = ({ name, value, handelFormChange, placeholder, disabled = false }) => {
  const initialInputValue = useCallback(() => {
    if (!isNaN(value)) {
      return Number(value).toLocaleString()
    } else return ''
  }, [])

  const [inputValue, setInputValue] = useState(initialInputValue())

  useEffect(() => {
    if (value === '') {
      setInputValue('')
    }
  }, [value])

  const parseShorthand = val => {
    const lower = val.toLowerCase().replace(/,/g, '')
    if (lower.endsWith('k')) return parseFloat(lower) * Math.pow(10, 3)
    if (lower.endsWith('m')) return parseFloat(lower) * Math.pow(10, 6)
    if (lower.endsWith('b')) return parseFloat(lower) * Math.pow(10, 9)
    return parseFloat(lower)
  }

  function isShorthandInputValid(input) {
    if (input === '') return true // Allow empty field
    return /^(\d+)?(\.\d*)?[kKmMbB]?$/.test(input)
  }

  const handelChange = e => {
    let val = e.target.value

    if (val === '') {
      setInputValue('')
      handelFormChange(e)
      return
    }
    if (val.includes(',')) {
      val = String(val.replaceAll(',', ''))
    }
    if (isShorthandInputValid(val)) {
      setInputValue(val)
      if (val.toLowerCase().endsWith('k')) {
        e.target.value = value * Math.pow(10, 3)
      }
      if (val.toLowerCase().endsWith('m')) {
        e.target.value = value * Math.pow(10, 6)
      }
      if (val.toLowerCase().endsWith('b')) {
        e.target.value = value * Math.pow(10, 9)
      }
      handelFormChange(e)
    }
  }

  const handelBlurInput = event => {
    const { value } = event.target
    if (value === '') {
      return
    }
    const newValue = parseShorthand(value)
    setInputValue(Number(newValue).toLocaleString())
  }

  return (
    <InputBaseStyle
      name={name}
      value={inputValue}
      onChange={handelChange}
      onBlur={handelBlurInput}
      placeholder={placeholder}
      disabled={disabled}
    />
  )
}

export default NumericFormatModal

NumericFormatModal.propTypes = {
  name: PropTypes.string,
  value: PropTypes.any,
  handelFormChange: PropTypes.func,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool
}
